import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
export function CodeCoverageSummaryLine({ title, value, diff }) {
    const { t } = useTranslation();
    const diffValue = typeof diff !== 'undefined' ? Math.abs(Math.round(100 * diff) / 100) : 0;
    return (_jsxs("div", { className: "text-nowrap", children: [t(title), ":", ' ', value && `${value}%`, diffValue !== 0 && (_jsxs(_Fragment, { children: [' ', _jsx(Icon, { className: clsx('report-detail__icon', 'report-detail__icon--small', (diff ?? 0) < 0 ? 'icon--rotate-90deg' : 'icon--rotate-270deg'), name: "long-arrow-right" }), diffValue, "%"] }))] }));
}
